export const hasWindow = () => {
  try {
    return window !== undefined;
  } catch (error) {
    return false;
  }
};
